export default "__VITE_ASSET__D1fh3ra8__"